import { AssetTransaction } from "./asset_transaction";

export class MetalTransaction extends AssetTransaction {
	public hasAction(cancel: boolean = false): boolean {
		// Todo
		return false;
	}

	public isCancelable(): boolean {
		// Todo
		return false;
	}

	public get displayRecipient(): string {
		// Todo
		return "";
	}
}
